import MetricTemplate from './MetricTemplate'
import Metric from './Metric'
import Table from './Table'
import BarChart from './BarChart'
import PieChart from './PieChart'
import MetricGroup from './MetricGroup'
import Table2 from './Table2'
import DenaliReport from './DenaliReport'
import ViewLink from './ViewLink'
import { ClientFilter } from './filters/ClientFilter'
import { AdvisorHomeScopeFilter } from './filters/AdvisorHomeScopeFilter'
import DenaliAdvisorHomeScopePicker from './DenaliAdvisorHomeScopePicker'
import TreeMap from './dataviz/TreeMap'
import ScatterPlot from './dataviz/ScatterPlot'
import DenaliTreeMapEChart from './dataviz/TreeMap/echart'
import DenaliMetricRing from './dataviz/MetricRing/echart'
import GoalList from './list/GoalList'
import DenaliFunnel from './dataviz/Funnel'
import DenaliChloropleth from './dataviz/Chloropleth'
import DenaliBasicLine from './dataviz/BasicLine'
import DenaliComponentLine from './dataviz/ComponentLine'
import DenaliComponentBar from './dataviz/ComponentBar'
import { DenaliScopeProvider } from './filters/DenaliScopeProvider'
import { DenaliScopeFilter } from './filters/DenaliScopeFilter'
import DenaliScopePicker from './DenaliScopePicker'
import DenaliScopeTypePicker from './DenaliScopePicker/ScopeTypePicker'
import DenaliPresentationTable from './tables/DenaliPresentationTable'
import DenaliOpReport from './reports/DenaliOpReport'
import DenaliReportSummary from './reports/DenaliReportSummary'
import DenaliComponentScatter from './dataviz/ComponentScatter'
import DenaliComponentTreeMap from './dataviz/ComponentTreeMap'

const abundanceEngineExports = {
  /** Scope and Filtering */
  DAScopeProvider: DenaliScopeProvider,
  DAScopeFilter: DenaliScopeFilter,
  DAScopePicker: DenaliScopePicker,
  DAScopeTypePicker: DenaliScopeTypePicker,

  DAMetricTemplate: MetricTemplate,
  DAMetric: Metric,
  DAMetricGroup: MetricGroup,
  DATable: Table,
  DATable2: Table2,
  DAReport: DenaliReport,
  DAReportGrid: DenaliOpReport,
  DAReportSummary: DenaliReportSummary,
  DAViewLink: ViewLink,
  DAClientFilter: ClientFilter,
  DAAdvisorHomeScopeFilter: AdvisorHomeScopeFilter,
  DAMyClientsPicker: DenaliAdvisorHomeScopePicker,
  DAGoalList: GoalList,

  // Data visualizations:
  DABarChart: BarChart,
  DAPieChart: PieChart,
  DAScatterPlot: ScatterPlot,
  DATreeMap: TreeMap,
  DATreeMapEChart: DenaliTreeMapEChart,
  DAMetricRing: DenaliMetricRing,
  DAFunnel: DenaliFunnel,
  DAChloropleth: DenaliChloropleth,
  DABasicLine: DenaliBasicLine,

  DAComponentLine: DenaliComponentLine,
  DAComponentBar: DenaliComponentBar,
  DAComponentScatter: DenaliComponentScatter,
  DAComponentTreeMap: DenaliComponentTreeMap,

  DAPresentationTable: DenaliPresentationTable
}

export default abundanceEngineExports
